export default __webpack_public_path__ + "static/media/head-monkey.3ff37321.png";